<template>
    <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
        <!-- begin:: Header Mobile -->
        <!-- <KTHeaderMobile></KTHeaderMobile> -->
        <!-- end:: Header Mobile -->

        <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

        <!-- begin::Body -->
        <div class="d-flex flex-row flex-column-fluid page">
            <!-- begin:: Aside Left -->
            <KTAside v-if="asideEnabled"></KTAside>
            <!-- end:: Aside Left -->

            <div
                id="kt_wrapper"
                class="d-flex flex-column flex-row-fluid wrapper"
            >
                <!-- begin:: Header -->
                <KTHeader v-bind:title="pageTitle" :overlayShow="overlayShow" />
                <KTSubheader
                    v-if="subheaderDisplay"
                    v-bind:breadcrumbs="breadcrumbs"
                    v-bind:title="pageTitle"
                />
                <SettingsSubheader v-if="isSettingsPage" />
                <!-- end:: Header -->

                <!-- begin:: Content -->
                <div
                    id="kt_content"
                    class="content d-flex flex-column flex-column-fluid"
                    :class="isSettingsPage ? 'subheader-included' : ''"
                >
                    <!-- begin:: Content Body -->
                    <div class="d-flex flex-column-fluid">
                        <div class="container-fluid">
                            <BBAlert />
                            <!-- <transition name="fade-in-up"> -->
                            <transition>
                                <router-view @toggle-overlay="toggleOverlay" />
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
//import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import SettingsSubheader from "@/view/layout/subheader/SettingsSubheader.vue";
import Loader from "@/view/content/Loader.vue";
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import BBAlert from "@/view/content/BBAlert.vue";

export default {
    name: "Layout",
    components: {
        KTAside,
        KTHeader,
        //KTHeaderMobile,
        KTSubheader,
        KTStickyToolbar,
        Loader,
        BBAlert,
        SettingsSubheader,
    },
    data() {
        return {
            overlayShow: false,
        };
    },
    beforeMount() {
        // show page loading
        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

        // initialize html element classes
        HtmlClass.init(this.layoutConfig());
    },
    mounted() {
        // check if current user is authenticated
        // if (!this.isAuthenticated) {
        //   this.$router.push({ name: "login" });
        // }

        // Simulate the delay page loading
        setTimeout(() => {
            // Remove page loader after some time
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
        }, 2000);
    },
    methods: {
        toggleOverlay() {
            this.overlayShow = !this.overlayShow;
        },
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "breadcrumbs",
            "pageTitle",
            "layoutConfig",
        ]),
        /**
         * Check if the page loader is enabled
         * @returns {boolean}
         */
        loaderEnabled() {
            return !/false/.test(this.layoutConfig("loader.type"));
        },

        /**
         * Check if container width is fluid
         * @returns {boolean}
         */
        contentFluid() {
            return this.layoutConfig("content.width") === "fluid";
        },

        /**
         * Page loader logo image using require() function
         * @returns {string}
         */
        loaderLogo() {
            return process.env.BASE_URL + this.layoutConfig("loader.logo");
        },

        /**
         * Check if the left aside menu is enabled
         * @returns {boolean}
         */
        asideEnabled() {
            return !!this.layoutConfig("aside.self.display");
        },

        /**
         * Set the right toolbar display
         * @returns {boolean}
         */
        toolbarDisplay() {
            // return !!this.layoutConfig("toolbar.display");
            return false;
        },

        /**
         * Set the subheader display
         * @returns {boolean}
         */
        subheaderDisplay() {
            return false;
            //return !!this.layoutConfig("subheader.display");
        },

        /**
         * Check if current route is settings
         * @return {boolean}
         */
        isSettingsPage() {
            return this.$route.name === "settings";
        },
    },
    watch: {
        isAuthenticated(newValue) {
            if (!newValue) {
                this.$router.push({ name: "login" });
            }
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/sass/bb-styles/layout.scss";
</style>
